import { resolve } from 'node:path'
import { Command } from 'commander'
import {
  importDurableStreams,
  normalizeBaseUrl,
  parseHeader,
} from '../../lib/durable-stream-archive.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printJson, printKeyValue, printQuiet } from '../../output.js'

interface ImportOptions {
  archive: string
  serverUrl: string
  header: string[]
}

function collectHeader(value: string, previous: string[]): string[] {
  return [...previous, value]
}

export const durableStreamsImportCommand = new Command(`import`)
  .description(`Recreate streams from a tar.gz archive`)
  .requiredOption(`--archive <file>`, `Archive created by the export command`)
  .requiredOption(`--server-url <url>`, `Target Durable Streams server URL`)
  .option(
    `-H, --header <header>`,
    `Target request header in "Name: value" form; may be repeated`,
    collectHeader,
    []
  )
  .action(async (options: ImportOptions) => {
    const json =
      durableStreamsImportCommand.parent?.parent?.opts().json ?? false

    try {
      const headers: Record<string, string> = {}
      for (const value of options.header) {
        const [name, headerValue] = parseHeader(value)
        headers[name] = headerValue
      }

      const result = await importDurableStreams(
        {
          archive: resolve(options.archive),
          serverUrl: normalizeBaseUrl(options.serverUrl),
          headers,
        },
        {
          log: isQuiet()
            ? () => undefined
            : (message) => process.stderr.write(`${message}\n`),
        }
      )

      if (isQuiet()) {
        printQuiet(String(result.streamCount))
      } else if (json) {
        printJson(result)
      } else {
        printKeyValue([[`Streams imported:`, String(result.streamCount)]])
      }
    } catch (error) {
      await handleError(error, json, `durable-streams import`)
    }
  })
